export default __webpack_public_path__ + "d61467f06851d6263068016f51b38110.svg";